import {
  STORE_KEY_ID_LIST,
  evalCondition,
  storeGet,
} from 'mailup-react-helpers'
import { TOAST_VARIANT_SUCCESS, toastShow } from 'mailup-web-components'

import getIntl from 'Helpers/intl'

import type {
  ColumnName,
  PaginationState,
  SearchFiltersState,
} from 'Pages/RecipientsList/model'

import {
  searchFiltersToConditions,
  toSubscriptionStatus,
} from 'Pages/RecipientsList/recoil/services/results'

import {
  beRecipientApiExportByCustomSearchParams,
  beRecipientApiExportBySelectionParams,
} from 'Api/beRecipientApi'

export const bulkExportCSV = async ({
  mode,
  checked,
  searchFilters,
  columns,
  orderBy,
  orderDescending,
  fileType,
}: {
  mode: 'all' | 'selection'
  checked: number[]
  searchFilters: SearchFiltersState
  columns: ColumnName[]
  orderBy: PaginationState['orderBy']
  orderDescending: PaginationState['orderDescending']
  fileType: 'csv' | 'xlsx'
}): Promise<void> => {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const hasEngagement: boolean = evalCondition('co:DELSTATS OR co:ENGAGEMENT')

  //  do not export Engagement if hasn't option
  //  do not export Groups if hasn't option
  const safeColumns = columns.filter(
    (c) => !(c === 'Engagement' && !hasEngagement),
  )

  if (mode === 'selection' && checked.length > 0) {
    await beRecipientApiExportBySelectionParams(
      idList,
      { orderBy, orderDescending },
      {
        SelectedRecipientsID: checked,
        ExportedColumns: safeColumns,
        FileType: fileType,
      },
    )
  } else {
    const reqIn = {
      Conditions: searchFiltersToConditions(searchFilters),
      SubscriptionStatus: toSubscriptionStatus(searchFilters.status.value),
      ExportedColumns: safeColumns,
      FileType: fileType,
    }

    await beRecipientApiExportByCustomSearchParams(
      idList,
      {
        orderBy,
        orderDescending,
      },
      reqIn,
    )
  }
}

export const notifyBulkExportSuccess = (): void => {
  toastShow(
    getIntl().formatMessage({
      id: 'Load.RecipientsList.BulkExportSuccess',
    }),
    TOAST_VARIANT_SUCCESS,
  )
}
